import React, { useCallback, useContext } from 'react'
import LuxuryPlusLabel from './LuxuryPlusLabel'
import { isActiveLuxuryPlusMember, isLuxuryPlusEnabled } from 'loyalty/selectors/featureToggle'
import { connect } from 'react-redux'
import LuxuryPlusLabeledContainer from './LuxuryPlusLabeledContainer'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import LuxuryPlusInclusionsList from './LuxuryPlusInclusionsList'
import ModalContext from 'contexts/ModalContext'
import LuxPlusExclusiveInclusionsModal from './modals/LuxPlusExclusiveInclusionsModal'

interface Props {
  isLuxuryPlusEnabled: boolean,
  isActiveLuxuryPlusMember: boolean,
  forceShowInclusions?: boolean,
  loyaltyInclusions: App.PackageInclusion[] | App.OrderLoyaltyInclusion[],
  accommodationOffer?: App.Offer | App.OfferSummary
}

function LuxuryPlusInclusions(props: Props) {
  const { isLuxuryPlusEnabled, isActiveLuxuryPlusMember, forceShowInclusions, loyaltyInclusions, accommodationOffer } = props
  const showModal = useContext(ModalContext)

  const toggleModal = useCallback(() => {
    showModal(< LuxPlusExclusiveInclusionsModal accommodationOffer={accommodationOffer}/>)
  }, [accommodationOffer, showModal])

  if (!isLuxuryPlusEnabled) return null

  if (isActiveLuxuryPlusMember || forceShowInclusions) {
    return (
      <LuxuryPlusLabeledContainer
        data-testid="luxury-plus-inclusions-member"
        size="medium"
        labels={
          <>
            <CSSBreakpoint not="tablet"><LuxuryPlusLabel type="extra-inclusions-with" /></CSSBreakpoint>
            <CSSBreakpoint only="tablet"><LuxuryPlusLabel type="only-logo" /></CSSBreakpoint>
          </>
        }
      >
        <LuxuryPlusInclusionsList loyaltyInclusions={loyaltyInclusions} />
      </LuxuryPlusLabeledContainer>
    )
  }

  return (
    <div data-testid="luxury-plus-inclusions-non-member">
      <CSSBreakpoint not="tablet"><LuxuryPlusLabel type="extra-inclusions-with" onClick={toggleModal}/></CSSBreakpoint>
      <CSSBreakpoint only="tablet"><LuxuryPlusLabel type="only-logo" onClick={toggleModal} /></CSSBreakpoint>
    </div>
  )
}

function mapStateToProps(state: App.State) {
  return {
    isActiveLuxuryPlusMember: isActiveLuxuryPlusMember(state),
    isLuxuryPlusEnabled: isLuxuryPlusEnabled(state),
  }
}

export default connect(mapStateToProps)(LuxuryPlusInclusions)
